// do we have an external config element?
const configElement = document.getElementById('sme-config');

const config = {
    manufacturer: 0,
    brand: ''
};

if (configElement !== null) {
    var extenralConfig = JSON.parse(configElement.innerHTML);

    if (extenralConfig.hasOwnProperty('manufacturer')) {
        config.manufacturer = extenralConfig.manufacturer;

        switch (extenralConfig.manufacturer) {
            case 1:
                config.brand = 'audi';
                break;
            case 2:
                config.brand = 'seat';
                break;
            case 3:
                config.brand = 'skoda';
                break;
            case 4:
                config.brand = '';
                break;
        }
    }
}

export default config;